import React, { useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import Langs, { Localize } from "../../app/lang/langs";
import moment from "moment";
import styles from "./ContractsView.module.css";
import {
  dateBodyTemplate,
  statusFollowupBodyTemplate,
  typeFollowupBodyTemplate,
  statusItemTemplate,
  createDropdownFilterTemplate,
} from "./contractsTableUtils";

export default function MissionsSuivisDataTable({
  data,
  filters,
  globalFilterValue,
  onGlobalFilterChange,
  onRowDoubleClick,
  onValueChange,
  scrollHeight,
  followupStatuses,
  followupTypes,
  teamBodyTemplate,
}) {
  const dtRef = useRef(null);
  const date = moment().format("DD-MM-YYYY");

  const tableHeader = () => (
    <Row>
      <Col md={6}>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
          />
        </IconField>
      </Col>
    </Row>
  );

  const followupStatusRowFilterTemplate = createDropdownFilterTemplate(followupStatuses, statusItemTemplate);
  const followupTypeRowFilterTemplate = createDropdownFilterTemplate(followupTypes, statusItemTemplate);

  return (
    <div className={styles.collabsCard}>
      <DataTable
        ref={dtRef}
        onValueChange={onValueChange}
        exportFilename={`Suivis_missions_export_${date}`}
        value={data}
        dataKey="id"
        paginator
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        rowsPerPageOptions={[10, 25, 50]}
        rows={25}
        scrollable
        scrollHeight={scrollHeight}
        sortMode="single"
        filters={filters}
        currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
        onRowDoubleClick={onRowDoubleClick}
        selectionMode="single"
        header={tableHeader}
      >
        <Column field="prenom" header={Localize("prenom")} filter sortable style={{ minWidth: "14rem" }} />
        <Column field="nom" header={Localize("nom")} filter sortable style={{ minWidth: "14rem" }} />
        <Column field="status" header={Localize("Status")} sortable body={statusFollowupBodyTemplate} style={{ minWidth: "8rem" }} showFilterMatchModes={false} filter filterElement={followupStatusRowFilterTemplate} />
        <Column field="client" header={Localize("Client")} filter sortable style={{ minWidth: "14rem" }} />
        <Column field="current_team_name" header={Localize("Team")} body={teamBodyTemplate} filter sortable style={{ minWidth: "14rem" }} />
        <Column field="week" header={Localize("Semaine")} sortable dataType="text" style={{ minWidth: "9rem" }} body={d => parseInt(d.week) + 1} />
        <Column field="type" header={Localize("Suivi")} sortable body={typeFollowupBodyTemplate} style={{ minWidth: "12rem" }} showFilterMatchModes={false} filter filterElement={followupTypeRowFilterTemplate} />
        <Column field="comments" header={Localize("Comments")} style={{ maxWidth: "14rem", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }} />
        <Column field="created_at" header={Localize("created_at")} body={dateBodyTemplate} sortable dataType="date" style={{ minWidth: "10rem" }} />
        <Column field="createdBy" header={Localize("Suivi par")} sortable style={{ minWidth: "13rem" }} />
        <Column field="updated_at" header={Localize("updated_at")} body={dateBodyTemplate} sortable dataType="date" style={{ minWidth: "10rem" }} />
        <Column field="updatedBy" header={Localize("updated_by")} sortable style={{ minWidth: "13rem" }} />
      </DataTable>
    </div>
  );
}
